import styled from 'styled-components';

export const ContainerDados = styled.div`
  background-color: #fff;
  padding: 6px;
  border: 1px solid #d7d7d7;
  font-size: 0.8rem;
`;
